"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _awesomplete = _interopRequireDefault(require("awesomplete"));

var _sparqlClient = _interopRequireDefault(require("@retog/sparql-client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Prefixplete =
/*#__PURE__*/
function () {
  function Prefixplete(input) {
    var _this = this;

    var sparqlEndpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _sparqlClient["default"]("https://mtp.linked.solutions/sparql");
    var prefixGraphPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://mtp.linked.solutions/";

    _classCallCheck(this, Prefixplete);

    if (sparqlEndpoint.getSparqlResultSet) {
      this._sparqlEndpoint = sparqlEndpoint;
    } else {
      this._sparqlEndpoint = new _sparqlClient["default"](sparqlEndpoint);
    }

    this._input = input;
    this._prefixMappings = [];
    var self = this;
    var previousValue = input.value;
    var prefixSuggestions = [];
    var fullSuggestions = [];
    var awesomplete = new _awesomplete["default"](input);
    awesomplete.maxItems = 15;
    awesomplete.input.addEventListener("keyup", function (e) {
      if (input.value.length >= 2 && e.key !== "Enter" && input.value !== previousValue) {
        populateSuggestions();
      }

      return true;
    });
    input.addEventListener("awesomplete-selectcomplete", function (e) {
      if (input.value.trim().split(":").length < 2 || input.value.trim().split(":")[1] === "") {
        populateSuggestions();
        awesomplete.open();
      } else {
        _this.lookup();
      }
    });

    function getFullUri(prefixedUri) {
      var splitup = prefixedUri.split(":"); //console.log("%cPrefixplete > getFullUri", "color: #4527a0", splitup, prefixMappings);

      var mapping = self._prefixMappings.find(function (m) {
        return splitup[0] === m.prefix;
      });

      if (mapping) {
        return mapping.uri + splitup[1];
      } else {
        return prefixedUri;
      }
    }

    function getPrefixedUri(fullUri) {
      var uri = self._getPrefixedUri(fullUri);

      return uri != null ? uri : fullUri;
    }

    function populateSuggestions() {
      if (input.value.toString().indexOf(":") === -1) {
        previousValue = input.value;
        getPrefixUrlSuggestions(input.value).then(function (_) {
          awesomplete.list = prefixSuggestions.map(function (i) {
            return i.display;
          });
          awesomplete.open();
        });
      } else {
        previousValue = input.value;
        var splitup = input.value.toString().split(":");
        getFullSuggestions({
          prefix: splitup[0],
          url: getFullUri(input.value.toString())
        }).then(function (_) {
          awesomplete.list = fullSuggestions.map(function (i) {
            return i.display !== i.prefix + ":" ? i.display : undefined;
          }); //console.log("%cPrefixplete > populateSuggestions", "color: #4527a0", fullSuggestions.map(i => i.display !== i.prefix + ":" ? i.display : undefined));

          awesomplete.open();
        });
      }
    }

    function getPrefixUrlSuggestions(prefix) {
      var query = "PREFIX vann: <http://purl.org/vocab/vann/>\n" + "SELECT ?prefix ?uri WHERE {\n" + "    ?sub vann:preferredNamespacePrefix ?prefix ;\n" + "         vann:preferredNamespaceUri ?uri .\n" + "    FILTER ( REGEX (?prefix, \"" + prefix + "\") )\n" + "}\n" + "LIMIT 40";
      return self._sparqlEndpoint.getSparqlResultSet(query).then(function (json) {
        prefixSuggestions = json.results.bindings.map(function (binding) {
          return {
            prefix: binding.prefix.value,
            display: binding.prefix.value + ":",
            uri: binding.uri.value
          };
        });
        self._prefixMappings = self._prefixMappings.concat(prefixSuggestions);
        return true;
      });
    }

    function getFullSuggestions(prefix) {
      //console.log("%cPrefixplete > getFullSuggestions", "color: #4527a0", prefix);
      var query = "SELECT DISTINCT ?uri WHERE {\n" + "  GRAPH <" + prefixGraphPrefix + prefix.prefix + "> {\n" + "    ?uri ?p ?o .\n" + "    FILTER ( REGEX ( STR(?uri), \"" + prefix.url.replace(/\./g, "\\\\.") + "\") )\n" + "  }\n" + "}\n" + "LIMIT 40";
      return self._sparqlEndpoint.getSparqlResultSet(query).then(function (json) {
        fullSuggestions = json.results.bindings.map(function (binding) {
          return {
            prefix: prefix.prefix,
            display: getPrefixedUri(binding.uri.value),
            uri: binding.uri.value
          };
        });
        return true;
      });
    }
  }

  _createClass(Prefixplete, [{
    key: "_getPrefixedUri",
    value: function _getPrefixedUri(fullUri) {
      var mapping = this._prefixMappings.find(function (m) {
        return fullUri.startsWith(m.uri);
      });

      if (mapping) {
        return fullUri.replace(mapping.uri, mapping.prefix + ":");
      } else {
        return null;
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this2 = this;

      var prefixedUri = this._getPrefixedUri(value);

      if (prefixedUri) {
        this._input.value = prefixedUri;
      } else {
        this._input.value = value;
        var query = "PREFIX vann: <http://purl.org/vocab/vann/>\n" + "SELECT DISTINCT ?prefix ?uri WHERE {\n" + "    ?sub vann:preferredNamespacePrefix ?prefix ;\n" + "         vann:preferredNamespaceUri ?uri .\n" + "    FILTER ( REGEX (\"" + value + "\", \"^\" + str(?uri)) )\n" + "}\n" + "LIMIT 1";
        return this._sparqlEndpoint.getSparqlResultSet(query).then(function (json) {
          if (json.results.bindings[0]) {
            _this2._input.value = value.replace(json.results.bindings[0].uri.value, json.results.bindings[0].prefix.value + ":");

            _this2._prefixMappings.push({
              'prefix': json.results.bindings[0].prefix.value,
              'uri': json.results.bindings[0].uri.value
            });
          }

          return true;
        });
      }
    }
  }, {
    key: "lookup",
    value: function lookup() {
      this.action(this.value);
    }
  }, {
    key: "action",
    value: function action(value) {
      console.log("%cPrefixplete.action(value)", "color: #4527a0", "Value " + value + " selected, overwrite Prefixplete.action(value) method to have something happen.");
    }
  }, {
    key: "value",
    get: function get() {
      var splitup = this._input.value.toString().split(":");

      var mapping = this._prefixMappings.find(function (m) {
        return splitup[0] === m.prefix;
      });

      if (mapping && this._input.value.toString().indexOf(":") !== -1) {
        return mapping.uri + splitup[1];
      } else {
        return this._input.value.toString();
      }
    },
    set: function set(value) {
      this.setValue(value);
    }
  }]);

  return Prefixplete;
}();

exports["default"] = Prefixplete;
//# sourceMappingURL=prefixplete.js.map